"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractByTypename = exports.isTypename = void 0;
const isTypename = (node, typename) => !!node && node.__typename === typename;
exports.isTypename = isTypename;
/**
 * `typename`별로 유효한 값을 할당한 객체를 반환하는 유틸함수 [설명 더보기](https://oss.navercorp.com/place/local/issues/10887#issuecomment-8887487)
 * @param node `__typename` 필드를 가진 `graphql` 스키마
 * @returns `node`가 해당하는 `typename` key에 값이 할당된 객체
 */
const extractByTypename = (node) => {
    const typename = node === null || node === void 0 ? void 0 : node.__typename;
    if (!typename)
        return {};
    return {
        [typename]: node,
    };
};
exports.extractByTypename = extractByTypename;
